$(document).ready(function() {
  var url_1 = `/admin/${$('.url_position').data('obj')}/`
  var url_2 = "/move_position.js?toggle=up&other_id="
  var url_3 = "/move_position.js?toggle=down&other_id="
  var url_4 = `/admin/${$('.url_position').data('obj')}/update_position`

  document.querySelectorAll('.btn-position-up').forEach(btn => {
    btn.addEventListener('click', (e) => {
      let tbody  = e.target.closest('tbody');
      let parent = e.target.closest('.position');
      let id = parent.getAttribute('data-id');
      let other = parent.previousElementSibling;
      let other_id = other.getAttribute('data-id');
      let extra_params = extraParams();

      showUpdating()
      $.ajax({
        type: 'PUT',
        url: url_1+ id +url_2+ other_id,
        dataType: "json",
        error: function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.responseText);
          hideUpdating()
          showErrorMessage(xhr)
        },
        success: function(result) {
          showUpdated()
          tbody.insertBefore(parent, other);
          resetButtonAttribute(other, parent)
          var id_and_position = resetPositionLabel();
          updatePosition(id_and_position, extra_params)
        }
      })
    })
  });

  document.querySelectorAll('.btn-position-down').forEach(btn => {
    btn.addEventListener('click', (e) => {
      let tbody  = e.target.closest('tbody');
      let parent = e.target.closest('.position');
      let id = parent.getAttribute('data-id');
      let other = parent.nextElementSibling;
      let other_id = other.getAttribute('data-id');
      let extra_params = extraParams();

      showUpdating()
      $.ajax({
        type: 'PUT',
        url: url_1+ id +url_3+ other_id,
        dataType: "json",
        error: function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.responseText);
          hideUpdating()
          showErrorMessage(xhr)
        },
        success: function(result) {
          showUpdated()
          tbody.insertBefore(other, parent);
          resetButtonAttribute(other, parent)
          var id_and_position = resetPositionLabel();
          updatePosition(id_and_position, extra_params)
        }
      })
    })
  })

  document.querySelectorAll('.btn-position-resource').forEach(btn => {
    btn.addEventListener('click', (e) => {
      let tbody  = e.target.closest('tbody');
      let parent = e.target.closest('.position');
      let id = parent.getAttribute('data-id');
      let other = parent.nextElementSibling;
      let other_id = other.getAttribute('data-id');
      let url_1 = $('#url_position').data('url-1');
      let url_3 = $('#url_position').data('url-3');
      let extra_params = extraParams();

      showUpdating()
      $.ajax({
        type: 'PUT',
        url: url_1+ id +url_3+ other_id,
        dataType: "json",
        error: function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.responseText);
          hideUpdating()
        },
        success: function(result) {
          showUpdated()
          tbody.insertBefore(other, parent);
          resetButtonAttribute(other, parent)
          var id_and_position = resetPositionLabel();
          updatePosition(id_and_position, extra_params)
        }
      })
    })
  })

  document.querySelectorAll('.btn-position-adding').forEach(btn => {
    btn.addEventListener('click', (e) => {
      let tbody = document.querySelector('.position-body')
      let parent = e.target.closest('.position');
      let id = parent.getAttribute('data-id');
      let other = tbody.querySelector('.position');
      let other_id = other.getAttribute('data-id');
      let extra_params = extraParams();

      tbody.insertBefore(parent, tbody.querySelector('.position'))
      let btnUp   = parent.querySelector('.btn-position-up')
      let btnDown = parent.querySelector('.btn-position-down')

      btn.className += " hide"
      btnUp.className = btnUp.className.replace("hide", '')
      btnDown.className = btnDown.className.replace("hide", '')

      let id_and_position = resetPositionLabel();
      updatePosition(id_and_position, extra_params)

      showUpdating()
    })
  });

  function showUpdating() {
    document.querySelector('.update-status .updating').className = 'updating'
    hideUpdated(0)
  }

  function showUpdated() {
    document.querySelector('.update-status .updated').className = 'updated'
    hideUpdating()
    hideUpdated()
  }

  function hideUpdating() {
    document.querySelector('.update-status .updating').className = 'hide updating'
  }

  function hideUpdated(time = 3000) {
    setTimeout(function() {
      document.querySelector('.update-status .updated').className = 'hide updated'
    }, time)
  }

  function resetPositionLabel() {
    let tbody = document.querySelector('.position-body');
    let id_and_position = [];

    tbody.querySelectorAll('.position').forEach(function(elm, id){
      elm.querySelector('.current-position').innerHTML = id + 1
      elm.setAttribute('data-position', id + 1)
      id_and_position.push({
        position: elm.getAttribute('data-position'),
        id: elm.getAttribute('data-id')
      })
    })

    return id_and_position
  }

  function resetButtonAttribute(other, parent) {
    if (parent.nextElementSibling == null) {
      parent.querySelector('.btn-position-down').setAttribute('disabled', 'disabled')
      other.querySelector('.btn-position-down').removeAttribute('disabled')
    } else {
      parent.querySelector('.btn-position-down').removeAttribute('disabled')
    }

    if (parent.previousElementSibling == null) {
      parent.querySelector('.btn-position-up').setAttribute('disabled', 'disabled')
      other.querySelector('.btn-position-up').removeAttribute('disabled')
    } else {
      parent.querySelector('.btn-position-up').removeAttribute('disabled')
    }

    if (other.nextElementSibling == null) {
      other.querySelector('.btn-position-down').setAttribute('disabled', 'disabled')
    }
    if (other.previousElementSibling == null) {
      other.querySelector('.btn-position-up').setAttribute('disabled', 'disabled')
    }
  }

  function updatePosition(id_and_position, extra_params) {
    $.ajax({
      type: 'PUT',
      url: url_4,
      data: JSON.stringify({ id_and_position: id_and_position, extra_params: extra_params }),
      dataType: 'JSON',
      contentType: 'application/json',
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.responseText);
        hideUpdating()
      },
      success: function(result) {
        hideUpdating()
        showUpdated()
        resetPositionLabel();
      }
    })
  }

  function showErrorMessage(xhr) {
    // console.log(xhr.responseText)
    alert(xhr.responseJSON['errors']['base'][0]);
  }

  function extraParams() {
    var $extra_params = $('#extra-params');
    var extra_params  = {}

    if ($extra_params.data('meal') != undefined) {
      extra_params['from_meal'] = $extra_params.data('meal')
    }

    return extra_params
  }
})